import React from "react";
import Card from "../rairityNFTS/card/card";
import cardImg1 from "../../assets/cardImg1.png";
import cardImg2 from "../../assets/cardImg2.png";
import cardImg3 from "../../assets/cardImg3.png";
import cardImg4 from "../../assets/cardImg4.png";
import "./thirdSection.css";

const ThirdSection = () => {
  return (
    <div className="thirdSection-main-wrapper" style={{marginTop: '-5px'}}>
      <div className="thirdSection-inner-wrapper">
        <div>
          <h1>RARITY</h1>
          <p className="thirdSection-nft-Detail">
            Each NFT is algorithmically generated by combining 178 unique traits
            with varying rarity across categories.
          </p>
          <div className="nftCards-container">
            {/* <div className="df"> */}
            <span>
              <Card
                cardImg={cardImg1}
                heading={"COMMON (8,000)"}
                bgColor={"#BFDDB6"}
              >
                <p>
                  Exclusive holder chat room, market bots, giveaways on our
                  Discord channel <br/><br/> Monthly participation in 0.1 ETH raffle which
                  will be sent to the winners’ digital wallet<br/><br/> Future collections
                  access as a free reward <br/><br/> Staking your potato for Spud token
                  rewards
                </p>
              </Card>
              {/* </div> */}
              {/* <div className="right"> */}
              <Card
                cardImg={cardImg2}
                heading={"RARE (800)"}
                bgColor={"#A1BFDD"}
              >
                <p>
                  Everything common potato holders have access to <br/><br/> Monthly
                  participation in 0.3 ETH raffle which will be sent to the
                  winners’ digital wallet
                </p>
              </Card>
            </span>
            {/* </div> */}
            {/* <div className="df"> */}
            {/* <div className="pcright"> */}
            <span>
              <Card
                cardImg={cardImg3}
                heading={"SUPER RARE (80)"}
                bgColor={"#BEA2FD"}
              >
                <p>
                  Everything rare potato holders have access to <br/><br/> Monthly
                  participation in 0.6 ETH raffle which will be sent to the
                  winners’ digital wallet
                </p>
              </Card>
              {/* </div> */}
              {/* <div className="right"> */}
              <Card
                cardImg={cardImg4}
                heading={"LEGENDARY (8)"}
                bgColor={"#E8BF36"}
              >
                <p>
                  Everything super rare potato holders have access to <br/><br/> $500 worth
                  of ETH airdropped to wallet for every 30 days legendary potato
                  is held
                </p>
              </Card>
            </span>
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdSection;
